import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { ActivityLocationMismatchIndicatorComponent } from '../activity-location-mismatch-indicator/activity-location-mismatch-indicator.component';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'wilson-activity-drawer-location-mismatch',
  imports: [NzButtonModule, ActivityLocationMismatchIndicatorComponent],
  templateUrl: './activity-drawer-location-mismatch.component.html',
  styleUrls: ['./activity-drawer-location-mismatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityDrawerLocationMismatchComponent {
  @Input()
  isDisabled!: boolean;

  @Output()
  updateLocation = new EventEmitter();
}
